import React, { useEffect, useState, useCallback } from 'react';
import { FormGroup, Input, Container, Row, Col } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  ruleProductsListFetchData,
  addNewRuleProductData,
  removeRuleProductData,
} from '../../actions/offerRuleActions';
import { useLocation, useParams } from 'react-router-dom';
import qs from 'query-string';

const RuleDetailsPage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { ruleId } = useParams();

  const ruleProductsList = useSelector(
    (state) => state.ruleProductListFetchDataSuccess,
  );

  const [ruleName, setRuleName] = useState('');
  const [offerName, setOfferName] = useState('');
  const [emptyRowString] = useState('Products not set');

  useEffect(() => {
    // Get ruleName and offerName from query string
    const queryStringList = qs.parse(location.search);
    setRuleName(queryStringList.ruleName || '');
    setOfferName(queryStringList.offerName || '');

    dispatch(ruleProductsListFetchData(ruleId));
  }, [dispatch, location.search, ruleId]);

  const handleInputChange = useCallback(
    (event) => {
      const { type, checked, value } = event.target;
      if (type === 'checkbox') {
        if (checked) {
          dispatch(addNewRuleProductData(ruleId, value));
        } else {
          dispatch(removeRuleProductData(ruleId, value));
        }
      }
    },
    [dispatch, ruleId],
  );

  const renderProductRow = (product) => (
    <div key={product.productCode}>
      <Row className='promotion-row'>
        <Col md='1' className='white-border float-right'>
          <FormGroup check>
            <Input
              type='checkbox'
              value={product.productCode}
              defaultChecked={product.isOfferProduct}
              onChange={handleInputChange}
            />
          </FormGroup>
        </Col>
        <Col md='2' className='white-border'>
          {product.productCode}
        </Col>
        <Col md='9' className='white-border'>
          {product.productName}
        </Col>
      </Row>
    </div>
  );

  const noRowsExist = (
    <Row>
      <Col md='12' className='empty-data-row'>
        {emptyRowString}
      </Col>
    </Row>
  );

  const ruleProductsRows =
    ruleProductsList && ruleProductsList.length > 0
      ? ruleProductsList.map(renderProductRow)
      : noRowsExist;

  return (
    <div>
      <h4>Currently linked product for {offerName}</h4>
      <h5>Rule: {ruleName}</h5>
      <Container fluid>
        <Row>
          <Col md='1' className='column-header'>
            Select
          </Col>
          <Col md='2' className='column-header'>
            Product Code
          </Col>
          <Col md='9' className='column-header'>
            Name
          </Col>
        </Row>
        {ruleProductsRows}
      </Container>
    </div>
  );
};

export default RuleDetailsPage;
